import { render } from "./GroupsCell.vue?vue&type=template&id=19905b8c&scoped=true"
import script from "./GroupsCell.vue?vue&type=script&lang=js"
export * from "./GroupsCell.vue?vue&type=script&lang=js"

import "./GroupsCell.vue?vue&type=style&index=0&id=19905b8c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19905b8c"]])

export default __exports__